import { ReactNode } from 'react';
import { useCinematicReveal } from '../../hooks/useCinematic';
import { useReducedMotion } from '../../hooks/useReducedMotion';

interface CinematicRevealProps {
    children: (state: { headerStyle: React.CSSProperties; contentStyle: React.CSSProperties; ref: React.RefObject<HTMLElement>; headerVisible: boolean; contentVisible: boolean; }) => ReactNode;
    headerDelay?: number;
    contentDelay?: number;
}

export function CinematicReveal({ children, headerDelay = 0, contentDelay = 300 }: CinematicRevealProps) {
    const { ref, headerVisible, contentVisible, headerOpacity, headerTransform, contentOpacity, contentTransform } = useCinematicReveal({ headerDelay, contentDelay });
    const reduced = useReducedMotion();

    const headerStyle: React.CSSProperties = reduced ? {} : {
        opacity: headerOpacity,
        transform: headerTransform,
        transition: 'all 1.0s cubic-bezier(0.16, 1, 0.3, 1)',
        willChange: 'transform, opacity'
    };

    const contentStyle: React.CSSProperties = reduced ? {} : {
        opacity: contentOpacity,
        transform: contentTransform,
        transition: 'all 1.2s cubic-bezier(0.16, 1, 0.3, 1)',
        willChange: 'transform, opacity'
    };

    return <>{children({ headerStyle, contentStyle, ref, headerVisible, contentVisible })}</>;
}
